/**
 * 菜谱 Excel 导入 / 导出 / 模板
 * 表头与页面列表一致：菜品名称、分类、单人份售价、单人份成本
 */
import * as XLSX from 'xlsx'
import { categoryLabel, categoryFromLabel } from '@/constants/categories'

export const DISH_SHEET_HEADERS = ['菜品名称', '分类', '单人份售价', '单人份成本']
const PRICE_HEADERS = ['单人份售价', '售价']
const COST_HEADERS = ['单人份成本', '成本']

function downloadWorkbook(aoa, fileName, sheetName) {
  const ws = XLSX.utils.aoa_to_sheet(aoa)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, sheetName)
  XLSX.writeFile(wb, fileName)
}

export function downloadDishTemplate() {
  downloadWorkbook([DISH_SHEET_HEADERS], '菜谱导入模板.xlsx', '菜谱')
}

export function exportDishes(dishes) {
  const rows = (dishes || []).map((dish) => [
    dish.name,
    categoryLabel(dish.category),
    Number(dish.price).toFixed(2),
    Number(dish.cost).toFixed(2)
  ])
  downloadWorkbook([DISH_SHEET_HEADERS, ...rows], '菜谱.xlsx', '菜谱')
}

function findCol(headerRow, aliases) {
  return headerRow.findIndex((cell) => aliases.includes(String(cell || '').trim()))
}

export function parseDishFile(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = (e) => {
      try {
        const wb = XLSX.read(e.target.result, { type: 'array' })
        const sheet = wb.Sheets[wb.SheetNames[0]]
        if (!sheet) {
          reject(new Error('文件中没有工作表'))
          return
        }
        const aoa = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: '' })
        if (!aoa.length) {
          reject(new Error('表格为空'))
          return
        }
        const headerRow = aoa[0].map((c) => String(c || '').trim())
        const nameIdx = headerRow.indexOf('菜品名称')
        const categoryIdx = headerRow.indexOf('分类')
        const priceIdx = findCol(headerRow, PRICE_HEADERS)
        const costIdx = findCol(headerRow, COST_HEADERS)
        if (nameIdx < 0) {
          reject(new Error('未找到表头「菜品名称」，请先下载模板'))
          return
        }
        const dishes = []
        let skipped = 0
        aoa.slice(1).forEach((row) => {
          const name = String(row[nameIdx] || '').trim()
          const rawCategory = categoryIdx >= 0 ? row[categoryIdx] : ''
          const rawPrice = priceIdx >= 0 ? row[priceIdx] : ''
          const rawCost = costIdx >= 0 ? row[costIdx] : ''
          const emptyRow = !name && !String(rawCategory || '').trim() && rawPrice === '' && rawCost === ''
          if (emptyRow) return
          if (!name) {
            skipped += 1
            return
          }
          const category = categoryFromLabel(rawCategory)
          if (!category) {
            skipped += 1
            return
          }
          const price = Number(rawPrice)
          const cost = Number(rawCost)
          if (!Number.isFinite(price) || price < 0 || !Number.isFinite(cost) || cost < 0) {
            skipped += 1
            return
          }
          dishes.push({ name, category, price, cost })
        })
        resolve({ dishes, skipped })
      } catch (err) {
        reject(err)
      }
    }
    reader.onerror = () => reject(new Error('读取文件失败'))
    reader.readAsArrayBuffer(file)
  })
}
